/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

export const styleguideStyle = {
  fab: (theme: Theme) => ({
    position: "fixed",
    bottom: "2rem",
    right: "50%",
    zIndex: 1000,
    [theme.breakpoints.up("md")]: {
      bottom: "5rem",
    },
  }),
  stage: (theme: Theme) => ({
    position: "relative",
    backgroundColor: theme.palette.primary.main,
    padding: "2rem 0 3rem",
    overflow: "hidden",
    width: "100%",
    "*": {
      color: theme.palette.common.white,
    },
  }),
  backgroundLogo: {
    position: "absolute",
    height: "200%",
    width: "auto",
    top: "-20%",
    left: "75%",
    opacity: 0.2,
  },
  linkListSubheader: {
    backgroundColor: "transparent",
    position: "relative",
    lineHeight: 1,
  },
  appBar: (theme: Theme)=> ({
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
    padding: "0.25rem 0 0.5rem",
    borderBottom: `1px solid ${theme.palette.divider}`
  })
};
